import kaplay from "kaplay";
import "kaplay/global";
import { loadSplashAssets, startGameAssetLoad } from "./assets.js";
import { clearSave } from "./saveSystem.js";
import { registerIntroScene } from "../scenes/introScene.js";
import { registerBootScene } from "../scenes/bootScene.js";
import { registerGameScene } from "../scenes/gameScene.js";
import { registerCrashScene } from "../scenes/crashScene.js";
import { registerCreditsScene } from "../scenes/creditsScene.js";
import { registerSplashLoadingHooks } from "../scenes/splashLoading.js";

// ── Engine Initialisation ─────────────────────────────────────────────
kaplay({
    crisp: true,
    texFilter: "nearest",
    pixelDensity: Math.max(window.devicePixelRatio || 1, 2),
    background: [0, 0, 0],
    global: true,
    // Custom RAM splash via onLoading — hide KAPLAY's default loader
    loadingScreen: false,
});

loadRoot("./");
loadSplashAssets();

registerIntroScene();
registerBootScene();
registerGameScene();
registerCrashScene();
registerCreditsScene();

// KAPLAY onLoading draws the RAM fill; onLoad opens the title / press-any-key beat.
registerSplashLoadingHooks(() => {
    clearSave();
    go("intro", { assetsReady: true });
});

startGameAssetLoad();
